"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEMORIZE_STATE = exports.MEMORIZE_ELEMENT = void 0;
var random_1 = require("../utilities/random");
var i18next_1 = __importDefault(require("i18next"));
var MEMORIZE_ELEMENT;
(function (MEMORIZE_ELEMENT) {
    MEMORIZE_ELEMENT["RED"] = "red";
    MEMORIZE_ELEMENT["YELLOW"] = "yellow";
    MEMORIZE_ELEMENT["GREEN"] = "green";
    MEMORIZE_ELEMENT["PURPLE"] = "purple";
})(MEMORIZE_ELEMENT = exports.MEMORIZE_ELEMENT || (exports.MEMORIZE_ELEMENT = {}));
;
var MEMORIZE_STATE;
(function (MEMORIZE_STATE) {
    MEMORIZE_STATE[MEMORIZE_STATE["NEW_GAME"] = 0] = "NEW_GAME";
    MEMORIZE_STATE[MEMORIZE_STATE["LEVEL_START"] = 1] = "LEVEL_START";
    MEMORIZE_STATE[MEMORIZE_STATE["GAME_OVER"] = 2] = "GAME_OVER";
})(MEMORIZE_STATE = exports.MEMORIZE_STATE || (exports.MEMORIZE_STATE = {}));
var MESSAGE_MAX_SCORE = 27;
var Memorize = /** @class */ (function () {
    function Memorize(elements) {
        if (elements === void 0) { elements = []; }
        this._elements = elements;
        this._index = 0;
    }
    Object.defineProperty(Memorize.prototype, "state", {
        get: function () {
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Memorize.prototype, "length", {
        get: function () {
            return this._elements.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Memorize.prototype, "score", {
        get: function () {
            return Math.max(this.length - 1, 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Memorize.prototype, "currentElement", {
        get: function () {
            return this._elements[this._index];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Memorize.prototype, "message", {
        get: function () {
            return i18next_1.default.t("memorize_score_" + Math.min(this.score, MESSAGE_MAX_SCORE));
        },
        enumerable: false,
        configurable: true
    });
    Memorize.prototype.clear = function () {
        this._elements = [];
        this._index = 0;
        this.enter(MEMORIZE_STATE.NEW_GAME);
    };
    Memorize.prototype.start = function () {
        this._elements = [];
        this._index = 0;
        this.addRandomElement();
        this.enter(MEMORIZE_STATE.LEVEL_START);
    };
    Memorize.prototype.addRandomElement = function () {
        var keys = Object.keys(MEMORIZE_ELEMENT);
        var key = (0, random_1.randomValue)(keys);
        var element = MEMORIZE_ELEMENT[key];
        this._elements.push(element);
        this._index = 0;
    };
    Memorize.prototype.elementAt = function (index) {
        return this._elements[index];
    };
    Memorize.prototype.answer = function (element) {
        if (element != this.currentElement) {
            this.enter(MEMORIZE_STATE.GAME_OVER);
            return;
        }
        if (this._index >= this.length - 1) {
            this.addRandomElement();
            this.enter(MEMORIZE_STATE.LEVEL_START);
            return;
        }
        this._index++;
    };
    Memorize.prototype.enter = function (state) {
        this._state = state;
        if (this.stateListener) {
            this.stateListener(state);
        }
    };
    return Memorize;
}());
exports.default = Memorize;
